
const logout = (props) => {
    const { authHandler, logoutUrl } = props;

    authHandler(false);
    const target =
      logoutUrl && /^https?:\/\//i.test(logoutUrl)
        ? logoutUrl
        : `${window.location.origin}/login`;
    window.location.replace(target);
};

export default logout;